import initCookieConsent from './modules/cookie-consent';
import addWindowScrollPositionToDocument from './modules/viewport';
import initMenuToggle from './modules/menu-toggle';
import initLottie from './modules/lottie';
import swiper from './modules/swiper';
import initPopup from './modules/popup';

document.addEventListener('DOMContentLoaded', () => {
    addWindowScrollPositionToDocument();
    initCookieConsent();
    initMenuToggle();
    initLottie();
    initPopup();
    swiper.slider();
});
